import React, { Fragment } from 'react'
//import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import 'bootstrap/dist/css/bootstrap.min.css'

const divStyle = {
  backgroundColor: '#cccccc',
}

const div2Style = {
  marginTop: '-30px',
}

const linkStyle = {
  fontWeight: 'normal',
  color: 'grey',
  paddingRight: '15px',
}

const linkClickStyle = {
  fontWeight: 'normal',
  color: 'black',
  paddingRight: '15px',
}

const hrStyle = {
  margin: '0px !important',
  borderTop: '0px',
}

const subtitleStyle = {
  color: '#707070',
}

class BarAccounting extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const hdash = '/accounting/' + this.props.user
    const hstat = '/statistics/' + this.props.user
    const hvacations = '/myvacations/' + this.props.user
    const hcalendars = '/calendars/' + this.props.user
    return <Fragment><nav className="navbar navbar-expand-lg navbar-light" style={div2Style}><div className="container"><div className="collapse navbar-collapse" style={subtitleStyle}>Accounting</div></div></nav><nav className="navbar navbar-expand-lg navbar-light" style={divStyle}><div className="container"><div className="collapse navbar-collapse"><ul className="navbar-nav mr-auto"><li className="nav-item active"><a href={hdash} style={linkClickStyle}>Dashboard</a></li><li className="nav-item"><a href={hstat} style={linkStyle}>Statistics</a></li><li className="nav-item"><a href={hvacations} style={linkStyle}>My vacations</a></li><li className="nav-item"><a href={hcalendars} style={linkStyle}>Google Calendars</a></li></ul></div></div></nav><hr style={hrStyle} /></Fragment>
  }
}

BarAccounting.propTypes = {
  user: PropTypes.string,
}

export default BarAccounting
